import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { environment } from '../../../../../environments/environment';
import { AppState } from '../../../../store/app.state';
import {
  loadSubAccounts,
  loadSubAccountsSuccess,
  loadSubAccountsFailure,
} from '../../../../store/sub-accounts/sub-accounts.actions';
import {
  selectAllSubAccounts,
  selectSubAccountsLoading,
  selectSubAccountsError,
} from '../../../../store/sub-accounts/sub-accounts.selectors';
import { UserService } from '../../../../core/services/user.service';

@Component({
  selector: 'app-passport-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './passport-layout.component.html',
})
export class PassportLayoutComponent implements OnInit {
  isDppTheme = environment.theme.default === 'dpp';

  // Observables pour surveiller l'état du store
  subAccounts$: any;
  loading$: any;
  error$: any;

  constructor(
    private store: Store<AppState>,
    private userService: UserService
  ) {
    // Initialiser les observables
    this.subAccounts$ = this.store.select(selectAllSubAccounts);
    this.loading$ = this.store.select(selectSubAccountsLoading);
    this.error$ = this.store.select(selectSubAccountsError);

    // Surveiller les changements d'état
    this.subAccounts$.subscribe((subAccounts: any) => {
      console.log(
        'PassportLayoutComponent: Sous-comptes dans le store:',
        subAccounts
      );
    });

    this.loading$.subscribe((loading: any) => {
      console.log('PassportLayoutComponent: État de chargement:', loading);
    });

    this.error$.subscribe((error: any) => {
      if (error) {
        console.error('PassportLayoutComponent: Erreur dans le store:', error);
      }
    });
  }

  ngOnInit(): void {
    console.log(
      'PassportLayoutComponent: ngOnInit - Chargement des sous-comptes...'
    );
    // Charger les sous-comptes directement sans effects
    this.store.dispatch(loadSubAccounts());

    this.userService.getSubAccounts().subscribe({
      next: (response: any) => {
        console.log('PassportLayoutComponent: Réponse API directe:', response);
        const subAccounts =
          response.subAccounts || response.data || response || [];
        console.log(
          'PassportLayoutComponent: Sous-comptes extraits:',
          subAccounts
        );
        this.store.dispatch(loadSubAccountsSuccess({ subAccounts }));
      },
      error: (error: any) => {
        console.error('PassportLayoutComponent: Erreur API directe:', error);
        this.store.dispatch(
          loadSubAccountsFailure({
            error:
              error.message || 'Erreur lors du chargement des sous-comptes',
          })
        );
      },
    });
  }
}
